var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1A",
    d: "M4.897 7.526a.562.562 0 0 1 .794.794l-1.853 1.85a3.176 3.176 0 0 0 0 4.496 3.184 3.184 0 0 0 4.5 0l1.853-1.851a.562.562 0 0 1 .794.793L9.132 15.46a4.308 4.308 0 0 1-6.088 0 4.297 4.297 0 0 1 0-6.082l1.853-1.85Zm3.97-3.966a4.308 4.308 0 0 1 6.089 0 4.297 4.297 0 0 1 0 6.082l-1.853 1.85a.562.562 0 0 1-.794-.793l1.853-1.85a3.176 3.176 0 0 0 0-4.496 3.184 3.184 0 0 0-4.5 0L7.809 6.204a.562.562 0 0 1-.794-.793l1.853-1.85ZM11.25 6.47a.562.562 0 0 1 .794.793L6.75 12.55a.562.562 0 0 1-.794-.793L11.25 6.47Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1b780852bba5d2ccc0389a2d9d28baaf.svg";
export { ForwardRef as ReactComponent };